import Users from 'collections/users';

export default new Users();
